import { useLocation, useNavigate } from "react-router-dom";
import { ListChecks, LayoutGrid } from "lucide-react";

export default function UserNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const onBoard = location.pathname.startsWith("/use/board");

  const item = (active) =>
    `flex-1 min-h-[64px] flex flex-col items-center justify-center gap-1 font-bold text-base transition-colors duration-200 ${
      active ? "text-primary" : "text-foreground/60"
    }`;

  return (
    <nav data-testid="user-nav" className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t-2 border-border flex">
      <button data-testid="user-nav-routines" onClick={() => navigate("/use")} className={item(!onBoard)}>
        <ListChecks size={28} strokeWidth={2.5} />
        My Routines
      </button>
      <button data-testid="user-nav-board" onClick={() => navigate("/use/board")} className={item(onBoard)}>
        <LayoutGrid size={28} strokeWidth={2.5} />
        Talk Board
      </button>
    </nav>
  );
}
